import { useCallback, useContext } from "react";

import { DebtResponse } from './../../interfaces/Debt';
import { DebtResultContext } from './debt-context';


export const useDebtResult = () => {
  const { debtResult, setDebtResult } = useContext(DebtResultContext);
  const createDebtResult = useCallback(
    (newDebt: DebtResponse | undefined): void => {
      setDebtResult(newDebt);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debtResult]
  );

  const deleteDebtResult = useCallback((): void => {
    setDebtResult(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debtResult]);

  return {
    debtResult,
    createDebtResult,
    deleteDebtResult,
  };
};
